import { Message } from '../message';
import { User } from '../security/user';

export class Conversation {
	user: User;
	messageList: Message[];
}
